export default __webpack_public_path__ + "static/media/id-front.f69bd561.png";